import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

// Información de pago por transferencia bancaria
const BANK_INFO = {
  clabe: '722969010029200517',
  beneficiary: 'Fernando Avila',
  whatsapp: 'https://wa.me/2296847814'
};

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user, loading, profileComplete } = useAuth();
  const paymentId = searchParams.get('payment_id');
  const postPaymentTarget = profileComplete ? '/dashboard' : '/onboarding';

  useEffect(() => {
    // Redirigir al dashboard u onboarding después de 5 segundos
    const timer = setTimeout(() => {
      if (user) {
        navigate(postPaymentTarget);
      } else {
        navigate('/login');
      }
    }, 5000);

    return () => clearTimeout(timer);
  }, [user, navigate, postPaymentTarget]);

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #0a1a2a 0%, #162a3d 100%)',
        color: 'var(--text-primary)'
      }}>
        <div>Cargando...</div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #0a1a2a 0%, #162a3d 100%)',
      color: 'var(--text-primary)',
      fontFamily: 'var(--font-primary)',
      padding: '2rem',
      textAlign: 'center'
    }}>
      <div style={{
        background: 'rgba(255, 255, 255, 0.05)',
        backdropFilter: 'blur(10px)',
        padding: '3rem',
        borderRadius: '20px',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        maxWidth: '500px',
        width: '100%',
        boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.37)'
      }}>
        <div style={{
          background: 'rgba(76, 175, 80, 0.1)',
          border: '1px solid rgba(76, 175, 80, 0.3)',
          borderRadius: '12px',
          padding: '1.5rem',
          marginBottom: '1.5rem'
        }}>
          <div style={{
            fontSize: '3rem',
            marginBottom: '1rem',
            textAlign: 'center'
          }}>
            ✅
          </div>
          <h2 style={{
            margin: '0 0 0.5rem 0',
            color: '#4caf50',
            fontSize: '1.5rem',
            textAlign: 'center'
          }}>
            ¡Transferencia Recibida!
          </h2>
          <p style={{
            color: 'var(--text-secondary)',
            fontSize: '0.95rem',
            textAlign: 'center',
            margin: '0 0 1rem 0'
          }}>
            Hemos recibido la notificación de tu transferencia bancaria.
          </p>
          <div style={{
            background: 'rgba(0, 0, 0, 0.2)',
            padding: '0.75rem',
            borderRadius: '8px',
            marginBottom: '1rem'
          }}>
            <p style={{
              margin: 0,
              color: 'var(--text-secondary)',
              fontSize: '0.85rem',
              textAlign: 'center',
              lineHeight: '1.6'
            }}>
              Tu licencia será activada en <strong style={{ color: '#4caf50' }}>24-48 horas hábiles</strong> después de verificar tu comprobante de pago.
            </p>
          </div>
        </div>

        {/* Instrucciones de Activación Manual */}
        <div style={{
          background: 'linear-gradient(135deg, rgba(255, 201, 77, 0.1) 0%, rgba(255, 179, 0, 0.1) 100%)',
          border: '2px solid rgba(255, 201, 77, 0.3)',
          borderRadius: '12px',
          padding: '1.5rem',
          marginBottom: '1.5rem'
        }}>
          <h5 style={{
            margin: '0 0 1rem 0',
            color: '#ffc94d',
            fontSize: '1.1rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}>
            📋 <span>Siguiente Paso: Envía tu Comprobante</span>
          </h5>
          <p style={{
            color: 'var(--text-secondary)',
            fontSize: '0.9rem',
            margin: '0 0 1rem 0',
            lineHeight: '1.6'
          }}>
            Para completar la activación de tu licencia, envía tu comprobante de pago por WhatsApp:
          </p>

          {/* Datos de transferencia */}
          <div style={{
            background: 'rgba(0, 0, 0, 0.2)',
            borderRadius: '8px',
            padding: '1rem',
            marginBottom: '1rem'
          }}>
            <p style={{
              color: 'var(--text-secondary)',
              fontSize: '0.85rem',
              margin: '0 0 0.75rem 0',
              fontWeight: '600'
            }}>
              Datos de la transferencia:
            </p>
            <div style={{ marginBottom: '0.5rem' }}>
              <p style={{ margin: '0 0 0.25rem 0', color: 'var(--text-secondary)', fontSize: '0.75rem' }}>CLABE:</p>
              <p style={{ margin: 0, color: '#f5f5f5', fontSize: '0.9rem', fontFamily: 'monospace', fontWeight: '600' }}>
                {BANK_INFO.clabe}
              </p>
            </div>
            <div>
              <p style={{ margin: '0 0 0.25rem 0', color: 'var(--text-secondary)', fontSize: '0.75rem' }}>Beneficiario:</p>
              <p style={{ margin: 0, color: '#f5f5f5', fontSize: '0.9rem', fontWeight: '600' }}>
                {BANK_INFO.beneficiary}
              </p>
            </div>
          </div>

          <div style={{
            background: 'rgba(0, 0, 0, 0.2)',
            borderRadius: '8px',
            padding: '1rem',
            marginBottom: '1.5rem'
          }}>
            <p style={{
              color: 'var(--text-secondary)',
              fontSize: '0.85rem',
              margin: '0 0 0.5rem 0',
              fontWeight: '600'
            }}>
              Incluye en tu mensaje de WhatsApp:
            </p>
            <ul style={{
              margin: 0,
              paddingLeft: '1.5rem',
              color: 'var(--text-secondary)',
              fontSize: '0.85rem',
              lineHeight: '1.8'
            }}>
              <li>Tu <strong>comprobante de pago</strong> (captura o foto)</li>
              <li>El <strong>correo electrónico</strong> para activar tu licencia</li>
            </ul>
          </div>

          {/* Botón de WhatsApp */}
          <a
            href={BANK_INFO.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.75rem',
              width: '100%',
              background: 'linear-gradient(135deg, #128C7E 0%, #075E54 100%)',
              border: 'none',
              padding: '14px 28px',
              color: 'var(--text-primary)',
              borderRadius: '50px',
              fontSize: '1.05rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'transform 0.2s, box-shadow 0.2s',
              boxShadow: '0 4px 15px rgba(37, 211, 102, 0.4)',
              textDecoration: 'none'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(37, 211, 102, 0.6)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 15px rgba(37, 211, 102, 0.4)';
            }}
          >
            <span style={{ fontSize: '1.5rem' }}>💬</span>
            <span>Enviar Comprobante por WhatsApp</span>
          </a>

          <p style={{
            color: 'var(--text-secondary)',
            fontSize: '0.8rem',
            margin: '1rem 0 0 0',
            textAlign: 'center',
            fontStyle: 'italic'
          }}>
            ⏱️ Tiempo de activación: 24-48 horas hábiles
          </p>
        </div>
        <div style={{
          background: 'rgba(76, 175, 80, 0.1)',
          border: '1px solid rgba(76, 175, 80, 0.3)',
          borderRadius: '12px',
          padding: '1rem',
          marginBottom: '1.5rem'
        }}>
          <p style={{ margin: 0, color: '#4caf50', fontSize: '0.9rem' }}>
            ⏳ Serás redirigido automáticamente al dashboard en unos segundos...
          </p>
        </div>
        <button
          onClick={() => user ? navigate(postPaymentTarget) : navigate('/login')}
          style={{
            background: 'linear-gradient(135deg, #c5a059 0%, #dbb96a 100%)',
            border: 'none',
            padding: '12px 32px',
            color: '#0a1a2a',
            borderRadius: '50px',
            fontSize: '1rem',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'transform 0.2s, box-shadow 0.2s',
            boxShadow: '0 4px 15px rgba(197, 160, 89, 0.4)'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(197, 160, 89, 0.6)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 15px rgba(197, 160, 89, 0.4)';
          }}
        >
          {user ? 'Ir al Dashboard' : 'Iniciar Sesión'}
        </button>
      </div>
      <div style={{ marginTop: '2rem', color: 'var(--text-muted)', fontSize: '0.8rem' }}>
        Ascensos App © {new Date().getFullYear()}
      </div>
    </div>
  );
};

export default PaymentSuccess;
